import { ConfigDocument } from 'src/types/configuration';
import { Document } from 'src/types/flow';

// redux-persist can't serialize a browser File — JSON.stringify(new File(...))
// produces '{}', so a rehydrated attachedFiles entry keeps its `name` string
// but its `blobFile` round-trips into a plain object that is never
// `instanceof File`. That's a sufficient check on its own: a real File stays
// a real File (even a legitimately empty/0-byte one), while a rehydrated stub
// never is.
export const isAttachedFileValid = (file?: {
  blobFile?: File;
  name?: string;
}): boolean => file?.blobFile instanceof File;

export const hasAllRequiredDocuments = (
  documents: Document | undefined,
  configDocuments: ConfigDocument[] = []
): boolean =>
  configDocuments
    .filter((configDocument) => !!configDocument.required)
    .every((configDocument) => {
      const attachedFiles =
        documents?.[configDocument.file_key ?? '']?.attachedFiles ?? [];
      return attachedFiles.some(isAttachedFileValid);
    });
